import { Component, State, Prop, Method, h } from '@stencil/core';
import "../../ionic/ionic.module";

@Component({
  tag: 'app-features',
  styleUrl: 'app-features.css',
  shadow: false
})
export class AppFeatures {
  @State() @Prop({ mutable: true }) currImageId: string | number;

  firstImage: string | number;

  @Method() async handleClickExpander(id) {
    this.currImageId = id;
  }

  componentWillLoad() {
    this.currImageId = this.currImageId || this.firstImage || 1;
    // console.log('componentWillLoad', this.currImageId, this.firstImage);
  }

  renderImg(id: string | number) {
    // src={`https://imgplaceholder.com/500x324/${id.toString().repeat(6)}`}
    if (this.currImageId === id) {
      let imgName = id;
      switch (id) {
        case 1:
          imgName = 'whatsapp'
          break;
        case 2:
          imgName = 'qr-code'
          break;
        case 3:
          imgName = 'pager'
          break;
        case 4:
          imgName = 'plataformas'
          break;
        case 5:
          imgName = 'nuvem'
          break;
        case 6:
          imgName = 'relatorio'
          break;
      }
      return (
        <ion-row class="ion-justify-content-center ion-align-items-center">
          <ion-img class={`shadow feature-image feature-image-${imgName}`} src={`/assets/img/feature-${imgName}.webp`} alt={`Funcionalidade ${imgName}`}></ion-img>
        </ion-row>
      );
    }
    if (!this.firstImage) {
      this.firstImage = id;
    }
  }

  render() {
    return (
      <div id="features" class="block-container features-container">
        <ion-text class="features-header" color="light">
          <h2 class="center-title text-shadow">Funcionalidades</h2>
        </ion-text>
        <div class="features-block">
          <div class="features-left-block">
            {this.renderImg(1)}
            {this.renderImg(2)}
            {this.renderImg(3)}
            {this.renderImg(4)}
            {this.renderImg(5)}
            {this.renderImg(6)}
          </div>

          <div class="features-right-block">
            <ibl-accordion>


              <ibl-expander isOpen={true} defaultHeaderAction="open" onClickHeader={(e) => this.handleClickExpander(1)}>
                <ion-item class="feature-expander-item" lines="full" slot="header">
                  <ion-icon class="feature-icon-1" slot="start" name="logo-whatsapp" color="success"></ion-icon>
                  Envio por WhatsApp
                </ion-item>
                <ion-item class="feature-expander-item" lines="full" slot="content">
                  <div class="feature-content">
                    <p class="small-padding-bottom">
                      Envie o link do pager por whatsapp para que o cliente acompanhe o seu pedido direto do celular.
                    </p>
                    <p>
                      Envie também mensagens personalizadas para o cliente pelo whatsapp.
                    </p>
                    {/* <i>
                      <ion-text color="medium">
                        <p>
                          Para enviar WhatsApp é necessário que o celular ou tablet possua
                          <b>acesso a internet</b> e o aplicativo WhatsApp instalado.
                        </p>
                        <p>
                          Além disso, o <b>cliente precisa responder OK</b> para que o link seja liberado.
                        </p>
                      </ion-text>
                    </i> */}
                  </div>
                </ion-item>
              </ibl-expander>

              <ibl-expander isOpen={false} defaultHeaderAction="open" onClickHeader={(e) => this.handleClickExpander(2)}>
                <ion-item class="feature-expander-item" lines="full" slot="header">
                  <ion-icon class="feature-icon-1" slot="start" name="qr-code" color="dark"></ion-icon>
                  QR Code
                </ion-item>
                <ion-item class="feature-expander-item" lines="full" slot="content">
                  <div class="feature-content">
                    <p class="small-padding-bottom">
                      O cliente escaneia um QR Code para poder acompanhar seu pedido direto do celular.
                    </p>
                  </div>
                </ion-item>
              </ibl-expander>

              <ibl-expander isOpen={false} defaultHeaderAction="open" onClickHeader={(e) => this.handleClickExpander(3)}>
                <ion-item class="feature-expander-item" lines="full" slot="header">
                  <ion-icon class="feature-icon-1" slot="start" name="refresh" color="dark"></ion-icon>
                  Pager em tempo real
                </ion-item>
                <ion-item class="feature-expander-item" lines="full" slot="content">
                  <div class="feature-content">
                    <p class="small-padding-bottom">
                      O cliente acompanha seu pedido em tempo real direto do celular, e recebe uma notificação quando o pedido está pronto.
                    </p>
                  </div>
                </ion-item>
              </ibl-expander>

              <ibl-expander isOpen={false} defaultHeaderAction="open" onClickHeader={(e) => this.handleClickExpander(4)}>
                <ion-item class="feature-expander-item" lines="full" slot="header">
                  <ion-icon class="feature-icon-1" slot="start" name="phone-portrait" color="secondary"></ion-icon>
                  Disponível para todas as plataformas
                </ion-item>
                <ion-item class="feature-expander-item" lines="full" slot="content">
                  <div class="feature-content">
                    <p class="small-padding-bottom">
                      Disponível para todos dispositivos como celulares, tablets, computadores e notebooks.
                    </p>
                  </div>
                </ion-item>

              </ibl-expander>

              <ibl-expander isOpen={false} defaultHeaderAction="open" onClickHeader={(e) => this.handleClickExpander(5)}>
                <ion-item class="feature-expander-item" lines="full" slot="header">
                  <ion-icon class="feature-icon-1" slot="start" name="cloud" color="secondary"></ion-icon>
                  Sem instalação (baseado em nuvem)
                </ion-item>
                <ion-item class="feature-expander-item" lines="full" slot="content">
                  <div class="feature-content">
                    <p>
                      Por ser baseado na nuvem, dispensa o uso de servidores de rede, e
                      você ainda pode acessar o sistema a qualquer hora e em qualquer lugar.
                      Possui segurança e suporta mútiplos usuários simultâneos.
                    </p>
                  </div>
                </ion-item>
              </ibl-expander>

              <ibl-expander isOpen={false} defaultHeaderAction="open" onClickHeader={(e) => this.handleClickExpander(6)}>
                <ion-item class="feature-expander-item" lines="full" slot="header">
                  <ion-icon class="feature-icon-1" slot="start" name="stats-chart" color="secondary"></ion-icon>
                  Relatórios
                </ion-item>
                <ion-item class="feature-expander-item" lines="full" slot="content">
                  <div class="feature-content">
                    <p>
                      Tenha acesso a relatórios que possuem informações relevantes sobre o seu estabelecimento, como quantidade
                      de pessoas atendidas e valor do atendimento, com totais diários e mensais.
                      {/* Também é possível baixar o relatório de pager no formato <i>(.csv)</i>. */}
                    </p>
                  </div>
                </ion-item>
              </ibl-expander>


            </ibl-accordion >
          </div >
        </div >
      </div >
    );
  }
}
